<template>
  <div class="picCut">
    <el-dialog
      title="图片剪裁"
      :visible.sync="dialogVisible"
      class="crop-dialog"
      append-to-body
    >
      {{ option.autoCropWidth }}
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            @cropMoving="cropMoving"
          />
        </div>
      </div>
      <div class="action-box">
        <el-upload
          class="upload-demo"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleChangeUpload"
        >
          <el-button type="primary" plain icon="el-icon-edit"
            >更换图片</el-button
          >
        </el-upload>
        <!-- 这里的按钮可以根据自己的需求进行增删-->
        <div class="btnGroup">
          <el-button
            type="danger"
            plain
            @click="clearImgHandle"
            icon="el-icon-delete"
            >清除图片</el-button
          >
          <el-button
            type="primary"
            plain
            @click="rotateLeftHandle"
            icon="el-icon-refresh-left"
            >左旋转</el-button
          >
          <el-button
            type="primary"
            plain
            @click="rotateRightHandle"
            icon="el-icon-refresh-right"
            >右旋转</el-button
          >
          <el-button
            type="primary"
            plain
            @click="changeScaleHandle(1)"
            icon="el-icon-zoom-in"
            >放大</el-button
          >
          <el-button
            type="primary"
            plain
            @click="changeScaleHandle(-1)"
            icon="el-icon-zoom-out"
            >缩小</el-button
          >
          <el-button
            type="primary"
            plain
            @click="downloadHandle('blob')"
            icon="el-icon-download"
            >下载</el-button
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer-pitCut">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { upload } from "@/api/dataModel/OnlineTraining";
export default {
  data() {
    return {
      // 判断文件类型
      tag: 0,
      loading: false,
      //裁剪组件===============
      isPreview: false,
      dialogVisible: false,
      previewImg: "", // 预览图片地址
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "png", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        canMoveBox: true, // 截图框能否拖动
        autoCropWidth: 100, // 默认生成截图框宽度
        autoCropHeight: 100, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      fileInfo: { name: "" },
      // 防止重复提交
      //  loading: false,
      //===============
    };
  },
  mounted() {},
  methods: {
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // 上传按钮 限制图片大小和类型
    handleChangeUpload(file, fileList) {
      console.log("options上传按钮 限制图片大小和类型11", this.option);
      // this.$refs.cropper.cropW = 222;
      console.log("file++++++", file);
      this.fileInfo.name = file.name;
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(async () => {
        // base64方式
        // this.option.img = await fileByBase64(file.raw);
        // console.log(
        //   "URL.createObjectURL(file.raw)",
        //   URL.createObjectURL(file.raw)
        // );
        this.getBase64(file.raw).then((res) => {
          //  console.log("res", res);
          this.option.img = res;
        });

        // this.option.img = URL.createObjectURL(file.raw);
        this.loading = false;
        this.dialogVisible = true;
      });
    },
    // 放大/缩小
    changeScaleHandle(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 左旋转
    rotateLeftHandle() {
      this.$refs.cropper.rotateLeft();
    },
    // 右旋转
    rotateRightHandle() {
      this.$refs.cropper.rotateRight();
    },
    // 下载
    downloadHandle(type) {
      let aLink = document.createElement("a");
      aLink.download = "author-img";
      if (type === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          let downImg = window.URL.createObjectURL(data);
          aLink.href = window.URL.createObjectURL(data);
          aLink.click();
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          let downImg = data;
          aLink.href = data;
          aLink.click();
        });
      }
    },
    // 清理图片
    clearImgHandle() {
      this.option.img = "";
    },
    // 截图框移动回调函数
    cropMoving(data) {
      // 截图框的左上角 x，y和右下角坐标x，y
      // let cropAxis = [data.axis.x1, data.axis.y1, data.axis.x2, data.axis.y2]
      // console.log(cropAxis)
    },
    finish() {
      // 获取截图的 base64 数据
      // this.$refs.cropper.getCropData((data) => {
      //   console.log("data", data);
      // });
      // 获取截图的 blob 数据
      this.$refs.cropper.getCropBlob((blob) => {
        let file = new FormData();
        console.log("abc------blob", blob);
        var newFile = new File([blob], this.fileInfo.name, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });
        //  console.log("newFile", newFile);
        file.append("file", newFile);
        if (this.tag == 1) {
          file.append("bizType", "9001");
        }

        this.$emit("valWidthAndHeight", file);

        // upload(file).then((res) => {
        //   if (this.imgBtnVal == -1) {
        //     this.ruleForm.picName = res.data.fileName;
        //   } else {
        //     this.ruleForm.tableAddFormList[this.imgBtnVal].picName =
        //       res.data.fileName;
        //     console.log(this.ruleForm.tableAddFormList);
        //   }
        //   this.dialogVisible = false;
        //   this.$message.success("文件上传成功");
        // });
      });
      // 获取截图的 base64 数据
      // this.$refs.cropper.getCropData(data => {
      //     console.log(data)
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
.crop-dialog {
  width: 100%;
  .cropper-content {
    .cropper {
      width: auto;
      height: 400px;
    }
  }
  .upload-demo {
    margin-top: 10px;
  }
  .btnGroup {
    margin-top: 10px;
  }
  .dialog-footer-pitCut {
    height: 40px;
    float: right;
  }
  ::v-deep .el-dialog__footer {
    height: 60px;
  }
}
</style>
